import ApiClient from './ApiClient';
import {AxiosInstance, AxiosResponse} from 'axios';
import {ApiKeyCreatedResponse, ApiKeyResponse, CreateApiKeyRequest, UpdateApiKeyRequest,} from '../types/ApiKey/ApiKey';

export default class ApiKeyService extends ApiClient {
  private static get apiKeyClient(): AxiosInstance {
    return this.client;
  }

  public static async createApiKey(data: CreateApiKeyRequest): Promise<ApiKeyCreatedResponse> {
    let res = await this.apiKeyClient.request<CreateApiKeyRequest, AxiosResponse<ApiKeyCreatedResponse>>({
      method: 'POST',
      url: this.apiDomain + '/v1/apikey',
      data,
    });
    return res.data;
  }

  public static async listApiKeys(): Promise<ApiKeyResponse[]> {
    let res = await this.apiKeyClient.request<ApiKeyResponse[]>({
      method: 'GET',
      url: this.apiDomain + '/v1/apikey',
    });
    return res.data || [];
  }

  public static async getApiKey(id: string): Promise<ApiKeyResponse> {
    let res = await this.apiKeyClient.request<ApiKeyResponse>({
      method: 'GET',
      url: this.apiDomain + '/v1/apikey/' + id,
    });
    return res.data;
  }

  public static async updateApiKey(id: string, data: UpdateApiKeyRequest): Promise<ApiKeyResponse> {
    let res = await this.apiKeyClient.request<UpdateApiKeyRequest, AxiosResponse<ApiKeyResponse>>({
      method: 'PUT',
      url: this.apiDomain + '/v1/apikey/' + id,
      data,
    });
    return res.data;
  }

  public static async revokeApiKey(id: string): Promise<boolean> {
    let res = await this.apiKeyClient.request({
      method: 'DELETE',
      url: this.apiDomain + '/v1/apikey/' + id,
    });
    return res.status === 204;
  }
}
